/**
 * @generated SignedSource<<1592514e5e29045c92eb04938c9e5824>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueSearch_issueNavigatorGrouping$data = {
  readonly viewId?: string | null | undefined;
  readonly viewSettings?: {
    readonly groupByConfig: {
      readonly groupByField: {
        readonly fieldId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly isGroupingEnabled: boolean | null | undefined;
    readonly isHierarchyEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "issueSearch_issueNavigatorGrouping";
};
export type issueSearch_issueNavigatorGrouping$key = {
  readonly " $data"?: issueSearch_issueNavigatorGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueSearch_issueNavigatorGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueSearch_issueNavigatorGrouping",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "viewId"
        }
      ],
      "type": "JiraIssueSearchViewMetadata",
      "abstractKey": "__isJiraIssueSearchViewMetadata"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isGroupingEnabled"
            },
            {
              "concreteType": "JiraSpreadsheetGroupByConfig",
              "kind": "LinkedField",
              "name": "groupByConfig",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraField",
                  "kind": "LinkedField",
                  "name": "groupByField",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "fieldId"
                    }
                  ]
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "isHierarchyEnabled"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};

(node as any).hash = "c2b6dadde3dd7fc9e7ea45e07062a4af";

export default node;
